import { makeid } from 'utils/helpers/makeid';

import type { IBooleanOption, TFormItem, IStringBooleanOption } from '../types';

export const booleanOptions: IBooleanOption[] = [
  { label: 'Yes', value: true, key: makeid(10) },
  { label: 'No', value: false, key: makeid(10) },
];

export const stringBooleanOptions: IStringBooleanOption[] = [
  { label: 'Yes', value: 'true', key: makeid(10) },
  { label: 'No', value: 'false', key: makeid(10) },
];

export const criticalNoCallForm: TFormItem[] = [
  {
    key: makeid(10),
    title: '#1 Is a call to patient indicated?',
    type: 'radio',
    required: true,
    name: 'isCallIndicated',
    options: stringBooleanOptions,
    extra: [
      {
        type: 'checkbox',
        name: 'whyNotIndicated',
        key: makeid(10),
        options: [
          {
            value: 'Repeat reading recovered',
            label: 'Repeat reading recovered',
            key: makeid(10),
          },
          {
            value: 'Patient is Do Not Call',
            label: 'Patient is Do Not Call',
            key: makeid(10),
          },
          {
            value: 'Patient is on a hold status',
            label: 'Patient is on a hold status',
            key: makeid(10),
          },
          { value: 'Other', label: 'Other', key: makeid(10) },
        ],
        extra: [
          {
            type: 'text',
            name: 'whyNotIndicatedText',
            key: makeid(10),
          },
        ],
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title:
      '#2 Who did you attempt to call? Please note, call should be attempted two times.',
    type: 'checkbox',
    name: 'whoAttemptedCall',
    required: false,
    requiredIf: { key: 'isCallIndicated', value: 'true' },
    options: [
      { value: 'Primary Contact', label: 'Primary Contact', key: makeid(10) },
      {
        value: 'Secondary Contact',
        label: 'Secondary Contact',
        key: makeid(10),
      },
      {
        value: 'Emergency Contact',
        label: 'Emergency Contact',
        key: makeid(10),
      },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: '#3 What was the outcome of the attempt?',
    type: 'radio',
    required: false,
    name: 'attemptOutcome',
    options: [
      { label: 'Left voicemail', value: 'Left voicemail', key: makeid(10) },
      {
        label: 'Unable to leave voicemail',
        value: 'Unable to leave voicemail',
        key: makeid(10),
      },
      { label: 'Unavailable', value: 'Unavailable', key: makeid(10) },
      {
        label:
          'Requests callback (Note: Please DO NOT mark reading as reviewed)',
        value: 'Requests callback',
        key: makeid(10),
      },
      { label: 'Declined call', value: 'Declined call', key: makeid(10) },
    ],
    readingTypeFor: ['min'],
  },
  {
    key: makeid(10),
    title: '#4 Was the reading escalated?',
    type: 'radio',
    required: true,
    name: 'isReadingEscalated',
    options: stringBooleanOptions,
    extra: [
      {
        label: 'Escalated via',
        type: 'checkbox',
        name: 'escalatedVia',
        key: makeid(10),
        options: [
          {
            value: 'Phone',
            label: 'Phone',
            key: makeid(10),
          },
          {
            value: 'SMS',
            label: 'SMS',
            key: makeid(10),
          },
          {
            value: 'Email',
            label: 'Email',
            key: makeid(10),
          },
          {
            value: 'Other',
            label: 'Other',
            key: makeid(10),
          },
        ],
        extra: [
          {
            type: 'text',
            name: 'escalatedViaOther',
            key: makeid(10),
          },
        ],
      },
      {
        label: 'Reason',
        type: 'checkbox',
        name: 'escalatedReasons',
        key: makeid(10),
        options: [
          {
            value: 'Consecutive critical readings without improvement',
            label: 'Consecutive critical readings without improvement',
            key: makeid(10),
          },
          {
            value: 'Reading well outside of their normal range',
            label: 'Reading well outside of their normal range',
            key: makeid(10),
          },
          {
            value: 'Concerning trend in readings',
            label: 'Concerning trend in readings',
            key: makeid(10),
          },
        ],
      },
      {
        label: 'Reason',
        type: 'checkbox',
        name: 'notEscalatedReasons',
        key: makeid(10),
        options: [
          {
            value: 'Repeat reading recovered',
            label: 'Repeat reading recovered',
            key: makeid(10),
          },
          {
            value: 'Device/User Error',
            label: 'Device/User Error',
            key: makeid(10),
          },
          {
            value: 'Clinic Instructions',
            label: 'Clinic Instructions',
            key: makeid(10),
          },
          {
            value: 'Other',
            label: 'Other',
            key: makeid(10),
          },
        ],
        extra: [
          {
            type: 'text',
            name: 'notEscalatedReasonsOther',
            key: makeid(10),
          },
        ],
      },
    ],
    readingTypeFor: ['min'],
  },
];
